import { z } from "zod";
/** Initiate request to our internal STK gateway. */
export const mpesaInitiateRequest = z.object({
    shortcode: z.string(),
    amount: z.string(),
    phone_number: z.string(),
    account_number: z.string(),
});
/** Initiate response: gateway currently only returns a ResponseCode/Description. */
export const mpesaInitiateResponse = z.object({
    ResponseCode: z.union([z.string(), z.number()]),
    Description: z.string().optional(),
    /** Any other fields the gateway might add later. */
}).passthrough();
export const mpesaStatus = z.enum([
    "PENDING",
    "SUCCESS",
    "FAILED",
    "CANCELLED",
    "TIMEOUT",
    "UNKNOWN",
]);
